import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cx from 'bem-classnames';

import { getElementType, getUnhandledProps } from 'components/lib';

const Grid = props => {
  const { component, items, className } = props;
  const ComponentToRender = component;

  let content = <div />;

  if (!_.isEmpty(items)) {
    content = _.map(items, item => (
      <ComponentToRender key={`item-${item.id}`} item={item} />
    ));
  } else {
    content = <ComponentToRender />;
  }

  const ElementType = getElementType(Grid, props);
  const rest = getUnhandledProps(Grid, props);

  const classes = cx({ name: 'm-grid' }, props, className);

  return (
    <ElementType {...rest} className={classes}>
      {content}
    </ElementType>
  );
};

Grid.propTypes = {
  className: PropTypes.string,
  component: PropTypes.func.isRequired,
  items: PropTypes.array,
};

Grid.handledProps = ['items', 'component'];

export default Grid;
